module.exports = __webpack_public_path__ + "static/media/1.abcc3dd4.jpg";